export class ProfessionalConceptInput {
    EmployeeId: string;
    SchoolYearId: number;
    ConceptId: number;
    ShiftId: number;
}



// WEBPACK FOOTER //
// ./src/app/main/models/professional-concept/professional-concept-input.ts